import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import english from "./i18n/en-CA.json";
import french from "./i18n/fr-CA.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		debug: process.env.NODE_ENV === "development",
		interpolation: {
			escapeValue: false
		},
		resources: {
			en: {
				translation: english
			},
			fr: {
				translation: french
			}
		},
		detection: {
			order: ["querystring", "cookie"],
			lookupQuerystring: "lng"
		}
	});

export default i18n;
